module.exports = __webpack_public_path__ + "img/model_39_zh.528d2abc.jpg";